// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".multiselect-tag[data-v-468e2d16]{--tw-bg-opacity:1;--tw-text-opacity:1;background-color:rgba(217,217,217,var(--tw-bg-opacity));color:rgba(68,68,68,var(--tw-text-opacity));text-transform:capitalize}", "",{"version":3,"sources":["<no source>"],"names":[],"mappings":"AAAA,kCAAA,iBAAA,CAAA,mBAAA,CAAA,uDAAA,CAAA,2CAAA,CAAA,yBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
